import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import '../styles/PolicyPages.css';

const PrivacyPolicy = () => {
  return (
    <div className="policy-page">
      <div className="policy-container">
        <Link to="/" className="back-link">← Back to Home</Link>
        
        <h1 className="policy-title">Privacy Policy</h1>
        <p className="policy-updated">Last updated: February 2025</p>

        <section className="policy-section">
          <p>At QuitStick, your privacy matters to us. This Privacy Policy explains what information we collect, how we use it, and how we keep it safe.</p>
        </section>

        <section className="policy-section">
          <h2>1. Information We Collect</h2>
          <p>When you place an order or interact with our website, we may collect the following information:</p>
          <ul>
            <li><strong>Personal details:</strong> Name, email address, phone number, and delivery address</li>
            <li><strong>Payment information:</strong> Processed securely through our payment gateway; we do not store card or UPI details</li>
            <li><strong>Device & usage data:</strong> Browser type, IP address, pages visited, and time spent on our website (via cookies and analytics tools)</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>2. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Process and fulfill your orders</li>
            <li>Send order confirmations and shipping updates</li>
            <li>Respond to your customer service inquiries</li>
            <li>Improve our website and product offerings</li>
            <li>Send occasional marketing communications (only if you have opted in)</li>
          </ul>
          <p>We do not sell, rent, or share your personal information with third parties for their marketing purposes.</p>
        </section>

        <section className="policy-section">
          <h2>3. Cookies</h2>
          <p>Our website uses cookies to improve your browsing experience and understand how visitors use our site. You can disable cookies in your browser settings, though this may affect some functionality of the website.</p>
        </section>

        <section className="policy-section">
          <h2>4. Third-Party Services</h2>
          <p>We may share your information with trusted third-party service providers (such as courier partners and payment processors) solely for the purpose of fulfilling your order. These parties are contractually obligated to protect your data.</p>
        </section>

        <section className="policy-section">
          <h2>5. Data Security</h2>
          <p>We take reasonable precautions to protect your personal information from unauthorized access, misuse, or disclosure. However, no method of data transmission over the internet is completely secure, and we cannot guarantee absolute security.</p>
        </section>

        <section className="policy-section">
          <h2>6. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access the personal data we hold about you</li>
            <li>Request correction of inaccurate information</li>
            <li>Request deletion of your data, subject to legal obligations</li>
            <li>Opt out of marketing communications at any time</li>
          </ul>
          <p>To exercise any of these rights, please contact us at <a href="mailto:support@quitstick.in">support@quitstick.in</a>.</p>
        </section>

        <section className="policy-section">
          <h2>7. Changes to This Policy</h2>
          <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with a revised date. We encourage you to review this policy periodically.</p>
        </section>
      </div>
      
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
